module.exports = __webpack_public_path__ + "img/avatar5.e72ef082.png";